// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__F3AUb","list":"BalanceDue_list__305gT","listRow":"BalanceDue_listRow__3gXKZ","total":"BalanceDue_total__1CwCm"};